import React, { Component } from "react";
import { convertDateFormat } from "../../utils/helperFunctions";
import { MDBBtn, MDBDataTable } from "mdbreact";
import { Row, Col } from "reactstrap";
import Pagination from "../Common/Pagination";
import { translate } from "react-i18next";

class DeviceTable extends Component {
  state = {
    loadTable: false,
    deviceList: [],
    pagination: {},
    role: localStorage.getItem("role"),
  };

  columns = [
    {
      label: "Device ID",
      field: "deviceId",
      sort: "asc",
      width: 250,
    },
    {
      label: "Device Name",
      field: "name",
      sort: "asc",
      width: 250,
    },
    {
      label: "Created At",
      field: "createdAt",
      sort: "asc",
      width: 250,
    },
    //   {
    //     label: 'Action',
    //     field: 'action',
    //     width: 80,
    //   },
  ];
  superAdminColumn = [
    {
      label: this.props.t("dashboard.devicesID"),
      field: "deviceId",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.deviceName"),
      field: "name",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.createdAt"),
      field: "createdAt",
      sort: "asc",
      width: 150,
    },
    {
      label: "FV Last",
      field: "fvLastVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: "FV New",
      field: "fvNewVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: "A/C Details",
      field: "linkedAccount",
      width: 150,
    },
    {
      label: this.props.t("dashboard.action"),
      field: "action",
      width: 80,
    },
  ];

  componentDidMount() {
    const { devices } = this.props;
    if (devices && devices.length) {
      this.showTable(true);
    } else {
      this.showTable(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.devices !== this.props.devices &&
      this.props.devices &&
      this.props.devices.length
    ) {
      this.showTable(true);
    }
  }

  showTable = (loadTable) => {
    if (loadTable) {
      const {
        devices,
        // editGateway,
        // deleteGateway,
        pagination,
        updateFirmware,
        showLinkedAccountDetails,
      } = this.props;
      const rows = devices.map((devices, index) => {
        let gatewayRow = { ...devices };
        delete gatewayRow["userId"];
        gatewayRow.accountName = gatewayRow.account
          ? gatewayRow.account.companyName
          : "N/A";
        gatewayRow.accountEmail = gatewayRow.account
          ? gatewayRow.account.email
          : "N/A";
        gatewayRow.createdAt = convertDateFormat(
          gatewayRow.createdAt,
          "shortDateTime"
        );
        gatewayRow.linkedAccount = (
          <MDBBtn
            onClick={showLinkedAccountDetails.bind(this, gatewayRow)}
            tag="button"
            rounded
            size="sm"
            className="px-2 transparentBtn"
          >
            Linked A/C Details
          </MDBBtn>
        );
        gatewayRow.action = (
          // this.state.role === 'super_admin' ? (
          <MDBBtn
            onClick={() => updateFirmware(devices.deviceId)}
            tag="a"
            rounded
            size="sm"
            className="px-2 transparentBtn"
          >
            <i className="fas fa-cog mt-0"></i>
          </MDBBtn>
        );
        // ) : (
        // <>
        //   <MDBBtn
        //     // onClick={deleteGateway.bind(this, gatewayRow.id)}
        //     tag="a"
        //     rounded
        //     size="sm"
        //     className="px-2 transparentBtn"
        //   >
        //     <i className="fas fa-trash mt-0"></i>
        //   </MDBBtn>
        //   <MDBBtn
        //     // onClick={editGateway.bind(this, gatewayRow)}
        //     tag="a"
        //     rounded
        //     size="sm"
        //     className="px-2 transparentBtn"
        //   >
        //     <i className="fas fa-pencil-alt mt-0"></i>
        //   </MDBBtn>
        // </>
        // );
        return gatewayRow;
      });
      this.setState({
        loadTable,
        deviceList: {
          columns: this.superAdminColumn,
          rows: rows,
        },
        pagination,
      });
    } else {
      this.setState({ loadTable });
    }
  };

  render() {
    const { changePage, t } = this.props;
    const { loadTable, deviceList, pagination } = this.state;
    return (
      <React.Fragment>
        {loadTable ? (
          <>
            <MDBDataTable
              className="hideLastColSort table-pagination"
              bordered
              data={deviceList}
              paging={true}
              scrollX
              infoLabel={[
                t("dashboard.showing"),
                t("dashboard.to"),
                t("dashboard.of"),
                t("dashboard.result"),
              ]}
              searchLabel={t("dashboard.search")}
              entrieslabel={t("dashboard.showEntries")}
              paginationLabel={[t("dashboard.previous"), t("dashboard.next")]}
            />
            {/* <Row className="mt-3 mb-3">
              <Col lg={6}>
                <label>
                  Showing {pagination.currentPage * 10 - 9} to{' '}
                  {pagination.currentPage * 10} of all results
                </label>
              </Col>
              <Col lg={6} className="text-right">
                <Pagination
                  pagination={pagination}
                  changePage={(page) => changePage(page)}
                ></Pagination>
              </Col>
            </Row> */}
          </>
        ) : null}
      </React.Fragment>
    );
  }
}

export default translate("translations")(DeviceTable);
